import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import remove from '../../../../../Res/Icon/remove.png';
import firmwareUpgrade from '../../../../../Res/Icon/firmwareUpgrade.svg';
import epiReboot from '../../../../../Res/Icon/epiReboot.svg';
import './BoxObi.css';
import { connect } from 'react-redux';
import { updateEpisFirmwareManually, getEpikBoxData } from '../../../../../actions/EpikBoxes';
import Spinner from '../../../../Spinner/Spinner';
import ConfirmationModal from '../../../../ConfirmationModal';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import { createPortal } from 'react-dom';

class BoxObi extends Component {
  constructor() {
    super();
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      isLoading: false,
      epiFwUpdate: false,
      selectedObi: null,
    };
  }

  handleRebootObi = obi => {
    const { obiReboot } = this.props;
    obiReboot(obi?.deviceId);
  };

  updateEpiFirmware = (obi) => {
    this.setState({ epiFwUpdate: true, selectedObi: obi._id });
  };

  onConfirmEPIReboot = async obi => {
    const { boxDetails, updateEpisFirmwareManually, getEpikBoxData } = this.props;
    this.setState({ isLoading: true });

    await updateEpisFirmwareManually(this.token, boxDetails._id, obi?.macAddress);
    await getEpikBoxData(this.token, boxDetails._id);

    this.setState({ isLoading: false, epiFwUpdate: false });
  };

  renderModal(obi) {
    const { epiFwUpdate, selectedObi } = this.state;
    if (epiFwUpdate && obi._id === selectedObi) {
      return createPortal(
        <ConfirmationModal
          isOpen={epiFwUpdate}
          onCancel={() => {
            this.setState({ epiFwUpdate: false });
          }}
          headerText={`EPI Firmware Update Required`}
          bodyText={`There is a firmware update required on the EPI's on the device. This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={() => this.onConfirmEPIReboot(obi)}
        />,
        document.body, // Render the modal outside the component's DOM hierarchy
      );
    }
  }

  render() {
    const {
      onObiSelect,
      onBoxEpiDelete,
      selected,
      enableBoxEdit,
      user,
      boxObisDetails,
    } = this.props;
    const { isLoading } = this.state;
    const { setDcUpdatePopup } = this.props; // Destructuring from props

    const activeBtnStyle = {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
    };

    return (
      <>
        {boxObisDetails.length > 0 &&
          boxObisDetails.map(({ obi, portObiSystemStatus }, index) => {
            const obiSelected = selected && selected._id === obi._id;
            const containerClassName = obiSelected ? 'boxObiContainer selected' : 'boxObiContainer';
            const obiStatus = portObiSystemStatus?.sp1ServiceStatus?.status;
            const obiCondition =
              obiStatus?.startsWith('Registered') && obiStatus?.includes('172.16.16.1');
            const active = obiCondition ? true : false;
            return (
              <>
                <div
                  key={index}
                  className={containerClassName}
                  onClick={() => {
                    onObiSelect(obi);
                  }}
                >
                  {isLoading ? <Spinner /> : null}
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      paddingLeft: '5px',
                      paddingTop: '2px',
                    }}
                  >
                    {active ? (
                      <div style={{ ...activeBtnStyle, background: '#0cd60c' }} />
                    ) : (
                      <div style={{ ...activeBtnStyle, background: '#ffc107' }} />
                    )}
                  </div>
                  <div><strong>{`EPI #${index+1}`}</strong></div>
                  <div className="obiInfo">
                    <div className="infoLabel">
                      <FontAwesomeIcon fixedWidth className="labelIcon" icon="microchip" />
                      <h5>MAC Address</h5>
                    </div>
                    <span>{obi?.macAddress || 'N/A'}</span>
                  </div>
                  <div className="epi-footer">
                    <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }}>
                      <TooltipIcon
                        tipId={`${'reboot-epi'}-${obi?.macAddress?.replace(/\\{0,1}t|\\{1,2}$/gi, '')?.trim()}`}
                        onClick={ () => {
                          const divElement = document.getElementById('test-time-remaining');
                          const isHidden = divElement.getAttribute('hidden') !== null;
                          if (isHidden) {
                            setDcUpdatePopup({ show: true });
                          } else {
                            this.handleRebootObi(obi)
                          }
                        }}
                        imgSrc={epiReboot}
                        displayData="Reboot EPI"
                        placement="top"
                        customClass="epi-info"
                        customStyle={{
                          position: 'relative',
                          top: '3px',
                          height: '20px',
                        }}
                      />
                    </div>
                    {!obi?.macAddress.startsWith('9CADEF') && (
                      <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto' }}>
                        <TooltipIcon
                          tipId={`${'update-epi'}-${obi?.macAddress?.replace(/\\{0,1}t|\\{1,2}$/gi, '')?.trim()}`}
                          onClick={ () => {
                            const divElement = document.getElementById('test-time-remaining');
                            const isHidden = divElement.getAttribute('hidden') !== null;
                            if (isHidden) {
                              setDcUpdatePopup({ show: true });
                            } else {
                              this.updateEpiFirmware(obi)
                            }
                          }}
                          imgSrc={firmwareUpgrade}
                          displayData="EPI Firmware Update"
                          placement="top"
                          customClass="epi-info"
                          customStyle={{
                            position: 'relative',
                            top: '3px',
                            height: '30px',
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {enableBoxEdit && (
                  <div
                    className="delete-box-icon"
                    onClick={ () => {
                      const divElement = document.getElementById('test-time-remaining');
                      const isHidden = divElement.getAttribute('hidden') !== null;
                      if (isHidden) {
                        setDcUpdatePopup({ show: true });
                      } else {
                        onBoxEpiDelete(obi);
                      }
                    }}
                  >
                    <img
                      className="actions-icon"
                      style={{
                        position: 'relative',
                        right: '2.5rem',
                        top: '3px',
                        height: '20px',
                      }}
                      src={remove}
                      alt="remove"
                    />
                  </div>
                )}
                {this.renderModal(obi)}
              </>
            );
          })}
      </>
    );
  }
}

BoxObi.propTypes = { obi: PropTypes.any };

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    boxDetails: state.AppState.boxDetails.box,
  };
};

const mapDispatchToProps = dispatch => ({
  updateEpisFirmwareManually: (token, bid, macAddress) =>
    dispatch(updateEpisFirmwareManually(token, bid, macAddress)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxObi);
